import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonCommonModule } from '../../common/components/common.module';
import { TestimonialComponent } from './testimonial/testimonial.component';

@NgModule({
  declarations: [TestimonialComponent],
  imports: [CommonModule, SkeletonCommonModule],
  exports: [TestimonialComponent]
})
export class TestimonialModule {}
